import React from 'react';
import { Map, MapProps } from './map';
import { MapPlaceholder, MapPlaceholderWithPins } from './placeholder';

const MapWithPins = MapPlaceholderWithPins(MapPlaceholder);

export interface PlaceholderedMapProps extends MapProps {}
export const PlaceholderedMap: React.FC<PlaceholderedMapProps> = (props) => (props.center ? <Map {...props} /> : <MapWithPins {...props} />);
